import ApiRequest from '@/plugins/axios'
import _ from 'lodash'
import { buildSearchString } from '@/helper/Functions'

export default {
  getList (layerId, page, rowsPerPage, searchParams, sorting, options) {
    return ApiRequest.get('geo-object/layer/' + layerId + '/' + page + '/' + rowsPerPage + buildSearchString(searchParams, sorting), options)
  },
  get (objectId) {
    return ApiRequest.get('geo-object/' + objectId)
  },
  create (item) {
    let data = _.cloneDeep(item)
    data.features = []
    data.objects = []
    return ApiRequest.post('geo-object', data)
  },
  udpate (id, item, updateImmoscoutObject) {
    return ApiRequest.put('geo-object/' + id + (updateImmoscoutObject ? '?updateImmoscoutObject=true' : ''), item)
  },
  updateVector (id, vector) {
    return ApiRequest.put('geo-object/updateVector/' + id, { vector })
  },
  delete (id) {
    return ApiRequest.delete('geo-object/' + id)
  },
  export (layerId, { type, headlines }, searches) {
    return ApiRequest.post('geo-object/export/' + layerId + buildSearchString(searches), {
      type,
      headlines
    })
  },
  getCoords (objectId) {
    return ApiRequest.get('geo-object/coords/' + objectId)
  }
}
